import { PopStoreCreatorBusinessType } from './profile';

export enum SignupIntent {
  AvatarMe = PopStoreCreatorBusinessType.AvatarMe,
  Stan = 'stan', // ?
  RealEstate = PopStoreCreatorBusinessType.RealEstate,
  Generic = PopStoreCreatorBusinessType.Generic,
  AIEcho = PopStoreCreatorBusinessType.AIEcho,
  ExpertCooking = 'expert_cooking',
  ExpertFitness = 'expert_fitness',
  ExpertCoaches = 'expert_coaches',
}

export enum SignupEventIntent {
  RealEstateEvent = 'realestateevent',
}

/** UTM reg intents that map to CreatorCoach business type */
export const creatorCoachIntents = new Set([
  SignupIntent.ExpertCooking,
  SignupIntent.ExpertFitness,
  SignupIntent.ExpertCoaches,
]);
